export default "__VITE_ASSET__jzwaQaaX__"